"use strict";

var _interopRequireDefault = require("D:/work/dm/longda/web/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.panelgroup = panelgroup;
var _request = _interopRequireDefault(require("@/utils/request"));
function panelgroup() {
  return (0, _request.default)({
    url: 'manage/dashboard/count',
    method: 'get'
  });
}